import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { IGetContractorEmployeesResponseDto } from "./getContractorEmployees.command";

export class GetContractorEmployeesByPassengerIdCommand extends IRequestCommand<IGetContractorEmployeesResponseDto,
  ErrorDetails,
  IGetContractorEmployeesByPassengerCommandParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'contractorEmployees/byPassenger/{passengerId}/paginated?page=1&size=1000&column=name&sort=ASC&find=';
  override _needAuthenticate = true;

  public override setParameters(parameters: IGetContractorEmployeesByPassengerCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{passengerId}',
      parameters.passengerId.toString());
    if (!!parameters.name) {
      this._commandUrl += parameters.name;
    }
  }
}

export interface IGetContractorEmployeesByPassengerCommandParameters extends ICommandParameters {
  passengerId: string;
  name?: string;
}
